export default __webpack_public_path__ + "a6149edb5361ab707badbefb56bd7e5d.svg";